import { useState } from 'react';
import { User } from '../../types/mold';
import { X } from 'lucide-react';

const NextAssigneeModal: React.FC<{
  isOpen: boolean;
  isCurrentAssignee: boolean;
  onClose: () => void;
  onConfirm: (newAssignee: string) => void;
  assignees: Array<User>;
  newAssignee: User;
}> = ({ isOpen, onClose, onConfirm, assignees, newAssignee, isCurrentAssignee }) => {
  const isInAssignableUsersList = assignees.some((assignee) => assignee.id === newAssignee.id);
  const defaultOption = isInAssignableUsersList ? newAssignee.id : assignees[0]?.id;

  const [newAssigneeId, setNewAssigneeId] = useState<string>(defaultOption?.toString() ?? '');

  const handleAssigneeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setNewAssigneeId(event.target.value);
  };

  const handleConfirm = () => {
    onConfirm(newAssigneeId);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="relative bg-white rounded-lg w-full max-w-md mx-4 z-50">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold">เปลี่ยนผู้รับผิดชอบ</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="mb-4">
            <label htmlFor="assignee-select" className="block text-sm font-medium text-gray-700 mb-2">
              เลือกผู้รับผิดชอบใหม่:
            </label>
            <select
              id="assignee-select"
              className="w-full p-2.5 sm:p-3 rounded-md border border-gray-300 h-12 bg-white"
              value={newAssigneeId}
              onChange={handleAssigneeChange}
            >
              {assignees.map((assignee: User) => (
                <option key={assignee.id} value={assignee.id}>
                  {assignee.fullname || assignee.username}
                </option>
              ))}
            </select>
          </div>
          <div className="flex justify-end gap-2">
            <button
              onClick={onClose}
              data-cy="cancel-button"
              className="px-4 py-2 text-lg text-gray-600 bg-gray-100 rounded-md hover:bg-gray-200"
            >
              ยกเลิก
            </button>
            <button
              onClick={handleConfirm}
              data-cy="confirm-button"
              className="px-4 py-2 text-lg text-white bg-blue-500 rounded-md hover:bg-blue-600"
            >
              ยืนยัน
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextAssigneeModal;